import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Opera-t használ a user.
 * @param ua - UserAgent.
 */
export default function isOpera (ua: string): boolean {
  return userAgentParser.isOpera(ua)
}
